export default function config({contentType = 'application/json'} = {}){
	return {
		headers: {
			'Access-Control-Allow-Origin': '*',
			'X-CITY': document.head.querySelector('meta[name="city"]').content,
			'Content-Type': contentType
		}
	}
}